import { OcSheetV1Events } from '@otto-ec/otto-components/sheet';
import { emitSheetOpen } from './SheetOpenEvents';

export enum SheetContentId {
    COUPONS = 'or_couponsSheet',
    VOUCHERS = 'or_vouchersSheet',
    COUPONS_AND_VOUCHERS = 'or_couponsAndVouchersSheet'
}

export interface SheetContentLoadedEvent {
    id: SheetContentId;
}

export class CouponsAndVouchersSheet {
    initialize() {
        return this._subscribeToContentLoadedEvent();
    }

    private _subscribeToContentLoadedEvent() {
        const unsubscribeContentApply: () => void = window.otto.components.sheetV1.events.contentApply.subscribe(
            (e: OcSheetV1Events['oc-sheet-content-apply']['detail']) => {
                if (e.instance.id === SheetContentId.COUPONS_AND_VOUCHERS) {
                    this._initializeTabListener();
                }
            }
        );
        return [unsubscribeContentApply];
    }

    private _initializeTabListener() {
        const couponsTab = document.getElementById('couponsTab');
        const vouchersTab = document.getElementById('vouchersTab');
        const sheetContent = document.getElementById('sheet_content');
        this._initializeClickListener(couponsTab, () => this._switchTab(couponsTab, vouchersTab, sheetContent, '/order/couponsSheet'));
        this._initializeClickListener(vouchersTab, () => this._switchTab(vouchersTab, couponsTab, sheetContent, '/order/vouchersSheet'));
        couponsTab?.focus();
    }

    private _initializeClickListener(element: HTMLElement | null, listener: () => void) {
        if (element && !element.dataset.initialized) {
            const conditionalListener = (evt: Event) => {
                if (this._acceptEvent(evt)) {
                    listener();
                }
            };
            element.addEventListener('click', conditionalListener);
            element.addEventListener('keypress', conditionalListener);
            element.dataset.initialized = 'true';
        }
    }

    private _loadSheet(url: string, targetElement: HTMLElement | null) {
        fetch(url)
            .then(response => response.text())
            .then(sheetContent => {
                if (targetElement) {
                    targetElement.innerHTML = sheetContent;
                    if (url === '/order/couponsSheet') {
                        emitSheetOpen({ id: SheetContentId.COUPONS });
                    } else {
                        emitSheetOpen({ id: SheetContentId.VOUCHERS });
                    }
                }
            })
            .catch(error => {
                console.error(`Error loading sheet from ${url}:`, error);
            });
    }

    private _acceptEvent(evt: Event): boolean {
        if (evt instanceof KeyboardEvent) {
            return evt.key === 'Enter' || evt.key === ' ';
        } else if (evt instanceof MouseEvent) {
            return evt.type === 'click';
        }
        return false;
    }

    private _switchTab(activeTab: HTMLElement | null, idleTab: HTMLElement | null, content: HTMLElement | null, sheetUrl: string) {
        if (!activeTab || !idleTab) {
            return;
        }

        if (activeTab.classList.contains('or_couponsAndVouchersSheet__active')) {
            /*                                            */
            return;
        }

        const activeLabel = activeTab.getElementsByClassName('or_couponsAndVouchersSheet__segment__label')[0];
        const idleLabel = idleTab.getElementsByClassName('or_couponsAndVouchersSheet__segment__label')[0];
        activeTab.classList.remove(...activeTab.classList);
        activeTab.classList.add('or_couponsAndVouchersSheet__segment', 'or_couponsAndVouchersSheet__active');
        activeLabel.classList.add('oc-copy--bold');

        idleTab.classList.remove(...idleTab.classList);
        idleTab.classList.add('or_couponsAndVouchersSheet__segment', 'or_couponsAndVouchersSheet__idle');
        idleLabel.classList.remove('oc-copy--bold');

        this._loadSheet(sheetUrl, content);
    }
}
